import React from 'react';
import { ToastNotification } from 'carbon-components-react';

export default function ErrorTemplate (props) {
  const { errors } = props;
  return (
    errors.map((error, i) => (
      <ToastNotification
        key={error.stack + '-' + i}
        kind='error'
        role='alert'
        iconDescription='Cerrar'
        title='Error al rellenar el formulario'
        caption={error.message}
        style={{ marginBottom: '.5rem', minWidth: '30rem' }}
      />
    )
    ));
}
